import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { ApiMetaSchemas } from "../utils";
import { BillApi } from "../../interfaces/bill/api";

const contractInstance = initContract();

export const billsContract = contractInstance.router(
  {
    getLatest: {
      method: "GET",
      path: "/:paymentMethodId",
      pathParams: z.object({
        paymentMethodId: z.string().uuid(),
      }),
      responses: {
        200: ApiMetaSchemas.countSchema(BillApi.billSchema),
      },
    },
  },
  {
    pathPrefix: "/bills",
  }
);
